import { options } from "@/store/options";

export default {
  getPriceRange: state => {
    if (state.paymentType === "monthly") {
      return [state.priceRange.monthly.min, state.priceRange.monthly.max];
    }
    return [
      state.priceRange.carPrice.min || state.prices.lowest,
      state.priceRange.carPrice.max || state.prices.highest
    ];
  },

  minimalAndMaximalPrice: state => {
    if (state.paymentType === "monthly") {
      return {
        min: options.priceRanges.monthly.min,
        max: options.priceRanges.monthly.max
      };
    }
    return {
      min: state.prices.lowest,
      max: state.prices.highest
    };
  },

  decodeGearboxCode() {
    const manualGearboxID = 55100;
    return code => (code === manualGearboxID ? "Manual" : "Automatic");
  },

  getYearRange() {
    const yearDifference = options.year.to - options.year.from + 1;
    return Array.from(
      { length: yearDifference },
      (value, i) => options.year.from + i
    );
  }
};
